import type { TSearchableWord, TSearchDocument, TSearchWordRange } from '../types/TSearch';

type TNormalizedWordText = {
  text: string;
  offsetMap?: number[];
};

const normalizeWordText = (original: string): TNormalizedWordText => {
  const normalized = original.trim().replace(/\s+/g, ' ');

  if (normalized === original) {
    return { text: normalized };
  }

  const offsetMap: number[] = [];
  let text = '';
  let spaceRunStart = -1;

  for (let index = 0; index < original.length; index += 1) {
    if (/\s/.test(original[index])) {
      if (spaceRunStart < 0) {
        spaceRunStart = index;
      }
      continue;
    }

    if (spaceRunStart >= 0 && text) {
      text += ' ';
      offsetMap.push(spaceRunStart);
    }

    spaceRunStart = -1;
    text += original[index];
    offsetMap.push(index);
  }

  return { text, offsetMap };
};

export const buildSearchDocument = (words: TSearchableWord[]): TSearchDocument => {
  let text = '';
  const wordRanges: TSearchWordRange[] = [];

  words.forEach((word) => {
    const normalizedWord = normalizeWordText(word.text);

    if (!normalizedWord.text) {
      return;
    }

    if (text) {
      text += ' ';
    }

    const start = text.length;
    text += normalizedWord.text;

    wordRanges.push({
      key: word.key,
      itemIndex: word.itemIndex,
      start,
      end: text.length,
      ...(normalizedWord.offsetMap ? { offsetMap: normalizedWord.offsetMap } : {}),
    });
  });

  return { text, wordRanges };
};
